import { Injectable } from '@angular/core';

@Injectable()
export class LocaleService {
  private _locale = '';
  private _currency = '';

  constructor() {}

  get locale(): string {
    return this._locale;
  }

  set locale(value: string) {
    this._locale = value;
  }

  get currency(): string {
    return this._currency;
  }

  set currency(value: string) {
    this._currency = value;
  }
}
